module.exports = __webpack_public_path__ + "img/mp-logo.b0045562.png";